import axios from "axios";
import { Dispatch } from "redux";
import baseUrl from "../../../ApiConfig";
import { setupInterceptorsTo } from "../../Authentication/Interceptors";
import {
  GetBloodGroupListActionTypes,
  GET_BLOOD_GROUP_LIST_FAIL,
  GET_BLOOD_GROUP_LIST_LOADING,
  GET_BLOOD_GROUP_LIST_SUCCESS,
} from "./ActionTypes";
import { GetBloodGroupListRes } from "./Model";

const userToken = localStorage.getItem("access");
const headers = {
  Accept: "application/json",
  "Content-type": "application/json",
  Authorization: `Bearer ${userToken}`,
};

export const getBloodGroupList = () => {
  return function (dispatch: Dispatch<GetBloodGroupListActionTypes>) {
    dispatch({
      type: GET_BLOOD_GROUP_LIST_LOADING,
    });
    setupInterceptorsTo(axios)
      .get(
        baseUrl.baseUrl + `/patientapp/api/patient/patient_bloodgroup_list`,
        {
          headers,
        }
      )
      .then((res) => {
        dispatch({
          type: GET_BLOOD_GROUP_LIST_SUCCESS,
          payload: res.data,
          errRes: "",
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_BLOOD_GROUP_LIST_FAIL,
          payload: {} as GetBloodGroupListRes,
          errRes: error.response.data.message,
        });
      });
  };
};
